import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderCargoRailyRecalculate from "./billings-order-cargo-raily-recalculate";
import BillingsOrderCargoRailyRecalculateParams from "./billings-order-cargo-raily-recalculate-params";

const useRecalculateCargoRailyBilling = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderCargoRailyRecalculate | null>(null);

  const load = async (
    params: BillingsOrderCargoRailyRecalculateParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.recalculateOrderCargoRailyBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useRecalculateCargoRailyBilling;
